import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ComponentPrimitive} from '../../../../../shared/classes/components/componentPrimitive';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {JobService} from '../../../../../jobs/services/job.service';
import {StateService} from '../../../../../core/services/state/state.service';
import {Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';
import {TextHelper} from '../../../../../shared/misc/text.helper';
import {TalentsDefinitions} from '../../../../../shared/talents/talentsDefinitions';
import {RightMatchAnalysisService} from '../../../services/right-match-analysis.service';

@Component({
    selector: 'app-right-matches-report-job-competencies',
    templateUrl: './right-matches-report-job-competencies.component.html',
    styleUrls: ['./right-matches-report-job-competencies.component.scss']
})
export class RightMatchesReportJobCompetenciesComponent extends ComponentPrimitive implements OnInit, OnDestroy {

    @Input() mobile = false;
    competencesOrdered: any = [];
    talents: any;
    talentsTexts: any;
    talentsPolarities: any;
    interviewQuestions: any;
    titleSep: string;
    reportDateFormat: string;

    private subscriptions = new Subscription();

    constructor(
        public translation: TranslateService,
        public rightMatchService: RightMatchAnalysisService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected stateService: StateService,
        protected router: Router,
        protected deviceService: DeviceDetectorService
    ) {
        super(stateService, translation, router, deviceService);
    }

    ngOnInit() {
        this.titleSep = TextHelper.checkTitleSep(this.translation.currentLang);
        this.reportDateFormat = TextHelper.dateFormat(this.translation.currentLang);
        this.checkTalentsDefinitions();
        this.checkCompetences();

        this.jobState.stateChanged$.subscribe(
            (res) => {
                if (res && res.jobToDisplayId) {
                    this.checkCompetences();
                }
                this.changeDetectorRef.markForCheck();
            }
        );

        this.translation.onLangChange.subscribe(
            (res) => {
                if (res) {
                    this.titleSep = TextHelper.checkTitleSep(res.lang);
                    this.reportDateFormat = TextHelper.dateFormat(res.lang);
                    this.checkTalentsDefinitions();
                }
            }
        );
    }

    checkTalentsDefinitions() {
        this.talents = new TalentsDefinitions().talents[this.translation.currentLang];
        this.talentsTexts = new TalentsDefinitions().talentsTxt[this.translation.currentLang];
        this.talentsPolarities = new TalentsDefinitions().talentsPolarities[this.translation.currentLang];
        this.interviewQuestions = new TalentsDefinitions().interviewQuestions[this.translation.currentLang];
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    checkCompetences() {
        // fuseTalentName(talents[competence[0]]), competence[1], talentsTexts[competence[0]], talentsPolarities[competence[0]].high, talentsPolarities[competence[0]].low
        let competences = [];
        for (let competenceItem of this.rightMatchService.competencies) {
            // tslint:disable-next-line:forin
            for (let key in competenceItem) {
                if (competenceItem.hasOwnProperty(key)) {
                    let questions = [];
                    for (let question of this.interviewQuestions[+key]) {
                        questions.push(question);
                    }
                    competences.push(
                        [
                            this.fuseTalentName(this.talents[+key]),
                            competenceItem[key],
                            this.talentsTexts[+key],
                            this.talentsPolarities[+key].high,
                            this.talentsPolarities[+key].low,
                            questions
                        ]
                    );
                }
            }
        }
        this.competencesOrdered = competences.sort(this.orderTalents);
    }

    onResize() {
    }

    orderTalents(a, b) {
        if (Intl.Collator('fr', {sensitivity: 'base', ignorePunctuation: true}).compare(a[0], b[0]) < 0) {
            return -1;
        }
        if (Intl.Collator('fr', {sensitivity: 'base', ignorePunctuation: true}).compare(a[0], b[0]) > 0) {
            return 1;
        }
        return 0;
    }

    fuseTalentName(talent) {
        if (talent.length > 1) {
            return talent.join(' ');
        }
        return talent[0];
    }

    get jobState(): any {
        return this.stateService.jobs;
    }

    get talentsScores() {
        if (this.rightMatchService.competencies) {
            return this.rightMatchService.competencies[0];
        }
        return;
    }

}
